<template>
  <div>
    <h1>Chargement...</h1>
  </div>
</template>